import {RECOVERY_CONTACTS} from '../actionTypes'
import {reducerFactory} from '../../lib/asyncUtil'

export default reducerFactory(RECOVERY_CONTACTS)
